import type { ReactNode } from 'react'
import { cn } from '@/utils/cn'

type Props = {
  title: string
  subtitle?: string
  actions?: ReactNode
  children: ReactNode
  className?: string
}

export function DashboardSection({ title, subtitle, actions, children, className }: Props) {
  return (
    <section className={cn('space-y-3', className)}>
      <div className="dashboard-section-heading flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h2 className="text-foreground">{title}</h2>
          {subtitle ? <p className="mt-0.5 text-sm font-normal normal-case tracking-normal text-muted-foreground">{subtitle}</p> : null}
        </div>
        {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
      </div>
      {children}
    </section>
  )
}
